import { SelectableOptionMenuItemType } from '@fluentui/react';
import { DropdownDividerOption as DividerOption } from './dropdown';

export const DropdownDividerOption = (key: string): DividerOption => ({
    itemType: SelectableOptionMenuItemType.Divider,
    text: '',
    key,
});
